import { ChangeDetectionStrategy, Component, forwardRef, model, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputTextComponent } from '../m020-c010-input-text/m020-c010-input-text.component';

type RangeValue = { from?: number; to?: number };

@Component({
    standalone: true,
    imports: [InputTextComponent],
    selector: './ui-input-range-text',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    templateUrl: './m020-c110-input-range-text.component.html',
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => InputRangeTextComponent), multi: true }],
})
export class InputRangeTextComponent implements ControlValueAccessor {
    range = model<{ from?: number; to?: number }>({});

    disabled = model(false);

    onChange?: (range: RangeValue | undefined) => void;
    onTouch?: () => void;

    writeValue(value: RangeValue) {
        this.range.set(value);
    }

    registerOnChange(fn: () => void) {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void) {
        this.onTouch = fn;
    }

    setDisabledState?(isDisabled: boolean) {
        this.disabled.set(isDisabled);
    }

    setFrom(from: number) {
        if (this.disabled()) return;

        this.range.set({ ...this.range(), from });
        this.onChange?.(this.range());
        this.onTouch?.();
    }
    setTo(to: number) {
        if (this.disabled()) return;

        this.range.set({ ...this.range(), to });
        this.onChange?.(this.range());
        this.onTouch?.();
    }
}
